"use client"
import {
    Navbar as NextUINavbar,
    NavbarContent,
    NavbarBrand,
    NavbarItem,
} from "@heroui/navbar";
import {Link} from "@heroui/link";
import {Button} from "@heroui/button";
import {DropdownItem, Dropdown, DropdownMenu, DropdownTrigger} from "@heroui/dropdown";
import NextLink from "next/link";
import {useMonitoring} from "@/components/monitoring";
import {usePathname, useRouter} from 'next/navigation'

export const Navbar = () => {
    const {
        onClickTrack,
        track
    } = useMonitoring()

    const router = useRouter()
    const pathname = usePathname()

    function onAction(key) {
        // track('Navbar Item Clicked', {navbar_item: key})
        if (key.startsWith('mail')) {
            return window.open(key)
        }
        router.push(key, {scroll: false})
    }

    const isTwitch = process.env.NEXT_PUBLIC_PLATFORM === 'twitch'
    const isRumble = process.env.NEXT_PUBLIC_PLATFORM === 'rumble'
    const isKick = !isTwitch && !isRumble
    const isTwitchVodPage = pathname === '/twitch-vod-downloader'

    const showTwitchNavLink = false;

    const menuItems = [
        ...((isKick || isTwitch) ? [{title: "Chrome Extension", url: "/chrome-extension"}] : []),
        ...(isKick && !isTwitchVodPage ? [{title: "Search for Kick Private VODs", url: "/channels"},] : []),
        ...(isKick ? [{title: "Kick Ads-Free Player", url: "/kick-ads-free-player"}] : []),
        ...(isKick ? [{title: "Kick Emoji Downloader", url: "/kick-emotes-downloader"}] : []),
        ...(isRumble ? [{title: "Rumble Emoji Downloader", url: "/rumble-emotes-downloader"}] : []),
        ...(isRumble ? [{title: "Kick Live Viewer Count", url: "/kick-live-viewers"}] : []),
        ...(isRumble ? [{title: "Free Video Inspector (ffprobe)", url: "/video-inspector"}] : []),
        ...(isKick ? [{title: "Kick Subtitles Downloader", url: "/kick-subtitles-downloader"}] : []),
        ...((isKick || isRumble) ? [{title: "Blog", url: "/blog"},] : []),
        ...((isRumble) ? [{title: "Rumble Statistics", url: "/statistics"},] : []),
        ...(isRumble ? [{title: "Most Followed Rumble Channels", url: "/rumble-most-followed-channels"}] : []),
        ...(isRumble ? [{title: "Most Viewed Rumble Channels", url: "/rumble-most-viewed-channels"}] : []),
        ...((isRumble) ? [{title: "Ambient Background Noise", url: "/ambient-background-noise"},] : []),
        ...((isRumble) ? [{title: "Income Counter", url: "/income-counter"},] : []),
        ...(isKick ? [{title: "Kick.com logo assets", url: "/kick-com-logo"},] : []),
        ...(isKick ? [{title: "Twitch VOD Downloader", url: "/twitch-vod-downloader"}] : []),
        ...((isKick || isTwitch) ? [{
            title: "Twitch Bulk Downloader",
            url: isKick
                ? "https://twitch-vod.download/twitch-bulk-clips-download"
                : "/twitch-bulk-clips-download",
        }] : []),
        {title: "Contact us", url: "/contact"},
        ...(isKick ? [{title: "Count-up", url: "/count-up"}] : []),
        ...(isKick ? [{title: "Youtube RSS Feed Generator", url: "/youtube-rss-feed-generator"}] : []),
        ...(isTwitch ? [{title: "Kick.com VOD downloader", url: "https://kick-video.download/"},] : []),
    ]

    return (
        <NextUINavbar data-ui={"navbar"} maxWidth="xl" position="sticky">
            <NavbarContent className="basis-1/5 sm:basis-full" justify="start">
                <NavbarBrand as="li" className="gap-3 max-w-fit">
                    <NextLink onClick={onClickTrack('Navbar Item', {navbar_item: 'Logo'})}
                              className="flex justify-start items-center gap-1" href="/" prefetch={false}>
                        {/*<Image alt="logo" width={60} height={60} src={"/kick-logo-green.svg"}/>*/}
                        {
                            isKick ? (
                                <svg style={{width: '60px'}} xmlns="http://www.w3.org/2000/svg" width="933" height="40"
                                     viewBox="0 0 933 300"
                                     fill="none">
                                    <g clipPath="url(#clip0_9790_492437)">
                                        <g clipPath="url(#clip1_9790_492437)">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M0 0H100V66.6667H133.333V33.3333H166.667V0H266.667V100H233.333V133.333H200V166.667H233.333V200H266.667V300H166.667V266.667H133.333V233.333H100V300H0V0ZM666.667 0H766.667V66.6667H800V33.3333H833.333V0H933.333V100H900V133.333H866.667V166.667H900V200H933.333V300H833.333V266.667H800V233.333H766.667V300H666.667V0ZM300 0H400V300H300V0ZM533.333 0H466.667V33.3333H433.333V266.667H466.667V300H533.333H633.333V200H533.333V100H633.333V0H533.333Z"
                                                  fill="#53FC18"/>
                                        </g>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_9790_492437">
                                            <rect width="933" height="300" fill="white"/>
                                        </clipPath>
                                        <clipPath id="clip1_9790_492437">
                                            <rect width="933.333" height="300" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            ) : isRumble ? (
                                <div className="flex shrink-0 items-center gap-1">
                                    <img alt="Rumble Video Downloader logo" className={"w-[45px] shrink-0"}
                                         src={"/rumble/icons/logo-my2.png"}></img>
                                    <img alt="Rumble Video Downloader logo" className={"w-[120px] shrink-0"} style={{ marginLeft: '-30px'}}
                                         src={"/rumble/icons/logo-text.png"}></img>




                                    {/*<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="48px" height="48px" baseProfile="basic"><path fill="#8bc34a" d="M38.544,16.899C34.578,13.008,23.053,5,16,5c-3,0-6,1-8,6S6,24,6,24s0,8,2,13s5,6,8,6	c7.053,0,18.578-8.008,22.544-11.899C40.204,29.473,42,27.422,42,24C42,20.578,40.204,18.527,38.544,16.899z"/><path fill="#fff" d="M16.472,19.839c-0.296,2.881-0.296,5.441,0,8.322c0.209,2.031,2.321,3.298,4.187,2.469	c1.979-0.879,4.578-2.234,7.324-4.22c1.629-1.178,1.629-3.642,0-4.82c-2.746-1.986-5.345-3.342-7.324-4.22	C18.793,16.541,16.681,17.808,16.472,19.839z"/></svg>*/}
                                    {/*<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="48px" height="48px" baseProfile="basic">*/}
                                    {/*    <symbol id="rumble-logo__mark-wordmark--word-only" fill="currentColor" viewBox="35 0 110 34">*/}
                                    {/*        <path d="M116.8 20.3a9.1 9.1 0 0 0 .7-3.3 9.2 9.2 0 0 0-.6-3.3 8 8 0 0 0-1.7-2.7 8 8 0 0 0-2.7-1.9 9 9 0 0 0-6.2-.3 7.8 7.8 0 0 0-2 1V3.3h-4.9v13.3c0 5.8 3.6 9 9.4 9a8.2 8.2 0 0 0 6.3-2.5 8.2 8.2 0 0 0 1.7-2.7Zm-4.5-5.1a4.6 4.6 0 0 1 .3 1.8 4.7 4.7 0 0 1-.3 1.8 4.3 4.3 0 0 1-1 1.4 4 4 0 0 1-1.3 1 4.5 4.5 0 0 1-1.7.3 4.5 4.5 0 0 1-1.7-.4 4.4 4.4 0 0 1-1.3-.8 4.4 4.4 0 0 1-1-1.5 5 5 0 0 1-.3-1.8c0-.7.1-1.3.4-1.8a4.2 4.2 0 0 1 .9-1.4 4 4 0 0 1 1.4-.9 4.4 4.4 0 0 1 1.6-.3 4.3 4.3 0 0 1 3 1.2c.5.4.8.9 1 1.4ZM50 9V13h-2c-1.4 0-2.5.4-3.2 1.2-.7.7-1.1 1.8-1.1 3.3V25h-4.8v-8c0-5.4 4-8 8.8-8h2.2Zm10.2 12.4c.6 0 1 0 1.5-.2a2.5 2.5 0 0 0 1-.6c.3-.4.6-.8.7-1.3.2-.5.3-1.2.3-2V9h4.8v8.5a10 10 0 0 1-.6 3.8c-.4 1-1 1.8-1.8 2.4-.7.7-1.6 1.1-2.6 1.4a11.9 11.9 0 0 1-6.6 0 7 7 0 0 1-2.6-1.4 6.5 6.5 0 0 1-1.7-2.4 10 10 0 0 1-.6-3.8V9h4.8v8.4c0 .7 0 1.4.2 2l.7 1.2c.3.3.7.5 1.1.6.4.2 1 .2 1.4.2Zm59 3.6V3.2h4.9V25h-4.8ZM126.6 13.7a8.4 8.4 0 0 0-.6 3.3 8.5 8.5 0 0 0 .6 3.3 8.5 8.5 0 0 0 1.9 2.7 8.8 8.8 0 0 0 6.4 2.6c1.2 0 2.2-.2 3.1-.5a9.1 9.1 0 0 0 2.5-1.3 8.2 8.2 0 0 0 1.8-1.8c.5-.7.9-1.4 1.1-2h-5.2c-.3.4-.7.8-1.3 1.1a4 4 0 0 1-2 .5c-.4 0-.9 0-1.3-.2a4.9 4.9 0 0 1-1.2-.7 4.6 4.6 0 0 1-1.7-2.4h13.1l.1-.5a5 5 0 0 0 0-.8 8.3 8.3 0 0 0-.6-3.3 8.1 8.1 0 0 0-1.9-2.7 9.5 9.5 0 0 0-6.5-2.5c-1.3 0-2.5.2-3.6.6a8.8 8.8 0 0 0-2.8 1.9 8.2 8.2 0 0 0-1.9 2.7Zm5.8-.7c.7-.5 1.6-.7 2.6-.7s1.8.2 2.4.7a4.4 4.4 0 0 1 1.4 2H131a4.3 4.3 0 0 1 1.5-2ZM81.6 16.4V25h4.9v-8.6c0-2 1-3.8 3.2-3.8 2.1 0 3 2.1 3 3.9V25h4.7v-8c0-5.1-2.6-8.5-7.5-8.5a8 8 0 0 0-5.9 2.2 8 8 0 0 0-5.8-2.2c-5 0-7.6 3.4-7.6 8.4V25h4.9v-8.5c0-1.8.8-4 2.8-4 2.2 0 3.2 1.8 3.3 3.9Z"></path>*/}
                                    {/*    </symbol>*/}
                                    {/*</svg>*/}
                                </div>
                            ) : <svg xmlns="http://www.w3.org/2000/svg" className={"w-[100px] h-[60px]"}
                                     viewBox="0 0 1140 380">
                                <defs>
                                    <style></style>
                                </defs>
                                <title>Asset 14</title>
                                <g id="Layer_2" data-name="Layer 2">
                                    <g id="Layer_1-2" data-name="Layer 1">
                                        <polygon className="cls-1"
                                                 points="170 170.01 100 170.01 100 190 170 190 170 270.01 60 270.01 20 230.01 20 20 100 20 100 90 170 90 170 170.01"/>
                                        <polygon className="cls-1"
                                                 points="470 270.01 230 270.01 190 230.01 190 90 270 90 270 190 290 190 290 90 370 90 370 190 390 190 390 90 470 90 470 270.01"/>
                                        <rect className="cls-1" x="490" y="90" width="80" height="180"/>
                                        <rect className="cls-1" x="490" y="20" width="80" height="50"/>
                                        <polygon className="cls-1"
                                                 points="740 170.01 670 170.01 670 190 740 190 740 270.01 630 270.01 590 230.01 590 20 670 20 670 90 740 90 740 170.01"/>
                                        <polygon className="cls-1"
                                                 points="920 170.01 840 170.01 840 190 920 190 920 270.01 800 270.01 760 230.01 760 130.01 800 90 920 90 920 170.01"/>
                                        <polygon className="cls-1"
                                                 points="1120 270.01 1040 270.01 1040 170.01 1020 170.01 1020 270.01 940 270.01 940 20 1020 20 1020 90 1080 90 1120 130.01 1120 270.01"/>
                                        <path className="cls-2"
                                              d="M1090,70h-50V0H930.21L879.72,70H790l-30,30V70H690V0H470V70H160.5L110,0H0V240L140,380H280V340l40,40H590V340l40,40H760V340l40,40h250l90-90V120ZM170,170H100v20h70v80H60L20,230V20h80V90h70ZM470,270H230l-40-40V90h80V190h20V90h80V190h20V90h80Zm100,0H490V90h80Zm0-200H490V20h80ZM740,170H670v20h70v80H630l-40-40V20h80V90h70Zm180,0H840v20h80v80H800l-40-40V130l40-40H920Zm200,100h-80V170h-20V270H940V20h80V90h60l40,40Z"/>
                                    </g>
                                </g>
                            </svg>
                        }

                        <p className="font-bold text-inherit">downloader</p>
                    </NextLink>
                </NavbarBrand>
            </NavbarContent>
            <NavbarContent
                className="flex basis-1/5 sm:basis-full"
                justify="end"
            >

                {
                    showTwitchNavLink ? <NavbarItem className="hidden sm:flex">
                        {/*<Link as={NextLink} href={'/twitch-vod-downloader'} prefetch={false}*/}
                        {/*      onClick={onClickTrack('Navbar Item', {navbar_item: 'Twitch VOD downloader'})}*/}
                        {/*      aria-label="Twitch VOD downloader">*/}
                        {/*    <NextImage alt={"twitch downloader"} src={"/twitch.png"} width={25} height={25}*/}
                        {/*               className={"mr-1"}></NextImage>*/}
                        {/*    Twitch VOD downloader*/}
                        {/*</Link>*/}
                        <Button
                            startContent={
                                <figure className="ScFigure-sc-mx5axi-1 dCkZJP">
                                    <svg overflow="visible" width="30px" height="30px" version="1.1" viewBox="0 0 40 40"
                                         x="0px" y="0px" className="ScSvg-sc-mx5axi-2 iAAiAK">
                                        <g>
                                            <polygon points="13 8 8 13 8 31 14 31 14 36 19 31 23 31 32 22 32 8"
                                                     className="ScBody-sc-mx5axi-3 dosCbL" fill={"#a970ff"}>
                                                <animate dur="150ms" begin="indefinite" fill="freeze" calcMode="spline"
                                                         keyTimes="0; 1" keySplines="0.25 0.1 0.25 1"
                                                         attributeName="points"
                                                         from="13 8 8 13 8 31 14 31 14 36 19 31 23 31 32 22 32 8"
                                                         to="16 5 8 13 8 31 14 31 14 36 19 31 23 31 35 19 35 5"></animate>
                                                <animate dur="250ms" begin="indefinite" fill="freeze" calcMode="spline"
                                                         keyTimes="0; 1" keySplines="0.25 0.1 0.25 1"
                                                         attributeName="points"
                                                         from="16 5 8 13 8 31 14 31 14 36 19 31 23 31 35 19 35 5"
                                                         to="13 8 8 13 8 31 14 31 14 36 19 31 23 31 32 22 32 8"></animate>
                                                <animate dur="50ms" begin="indefinite" fill="freeze" calcMode="spline"
                                                         keyTimes="0; 1" keySplines="0.25 0.1 0.25 1"
                                                         attributeName="points"
                                                         to="13 8 8 13 8 31 14 31 14 36 19 31 23 31 32 22 32 8"
                                                         from="16 5 8 13 8 31 14 31 14 36 19 31 23 31 35 19 35 5"></animate>
                                                <animate dur="75ms" begin="indefinite" fill="freeze" calcMode="spline"
                                                         keyTimes="0; 1" keySplines="0.25 0.1 0.25 1"
                                                         attributeName="points"
                                                         to="16 5 8 13 8 31 14 31 14 36 19 31 23 31 35 19 35 5"
                                                         from="13 8 8 13 8 31 14 31 14 36 19 31 23 31 32 22 32 8"></animate>
                                            </polygon>
                                            <polygon points="26 25 30 21 30 10 14 10 14 25 18 25 18 29 22 25"
                                                     className="ScFace-sc-mx5axi-4 fDFkyX" fill={"#ffffff"}>
                                                <animateTransform dur="150ms" begin="indefinite" fill="freeze"
                                                                  calcMode="spline" keyTimes="0; 1"
                                                                  keySplines="0.25 0.1 0.25 1" attributeName="transform"
                                                                  type="translate" from="0 0"
                                                                  to="3 -3"></animateTransform>
                                                <animateTransform dur="250ms" begin="indefinite" fill="freeze"
                                                                  calcMode="spline" keyTimes="0; 1"
                                                                  keySplines="0.25 0.1 0.25 1" attributeName="transform"
                                                                  type="translate" from="3 -3"
                                                                  to="0 0"></animateTransform>
                                                <animateTransform dur="50ms" begin="indefinite" fill="freeze"
                                                                  calcMode="spline" keyTimes="0; 1"
                                                                  keySplines="0.25 0.1 0.25 1" attributeName="transform"
                                                                  type="translate" from="3 -3"
                                                                  to="0 0"></animateTransform>
                                                <animateTransform dur="75ms" begin="indefinite" fill="freeze"
                                                                  calcMode="spline" keyTimes="0; 1"
                                                                  keySplines="0.25 0.1 0.25 1" attributeName="transform"
                                                                  type="translate" from="0 0"
                                                                  to="3 -3"></animateTransform>
                                            </polygon>
                                            <g className="ScEyes-sc-mx5axi-5 fAMMxB">
                                                <path
                                                    d="M20,14 L22,14 L22,20 L20,20 L20,14 Z M27,14 L27,20 L25,20 L25,14 L27,14 Z"
                                                    className="ScBody-sc-mx5axi-3 dosCbL" fill={"#a970ff"}>
                                                    <animateTransform dur="150ms" begin="indefinite" fill="freeze"
                                                                      calcMode="spline" keyTimes="0; 1"
                                                                      keySplines="0.25 0.1 0.25 1"
                                                                      attributeName="transform"
                                                                      type="translate" from="0 0"
                                                                      to="3 -3"></animateTransform>
                                                    <animateTransform dur="250ms" begin="indefinite" fill="freeze"
                                                                      calcMode="spline" keyTimes="0; 1"
                                                                      keySplines="0.25 0.1 0.25 1"
                                                                      attributeName="transform"
                                                                      type="translate" from="3 -3"
                                                                      to="0 0"></animateTransform>
                                                    <animateTransform dur="50ms" begin="indefinite" fill="freeze"
                                                                      calcMode="spline" keyTimes="0; 1"
                                                                      keySplines="0.25 0.1 0.25 1"
                                                                      attributeName="transform"
                                                                      type="translate" from="3 -3"
                                                                      to="0 0"></animateTransform>
                                                    <animateTransform dur="75ms" begin="indefinite" fill="freeze"
                                                                      calcMode="spline" keyTimes="0; 1"
                                                                      keySplines="0.25 0.1 0.25 1"
                                                                      attributeName="transform"
                                                                      type="translate" from="0 0"
                                                                      to="3 -3"></animateTransform>
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                </figure>
                            }
                            as={NextLink}
                            color="secondary"
                            target={"_blank"}
                            href="https://twitch-vod.download/"
                            variant="ghost"
                        >
                            Twitch VOD downloader
                        </Button>
                    </NavbarItem> : null
                }
                {isKick && !isTwitchVodPage ?
                    <NavbarItem className="hidden sm:flex">
                        <Link as={NextLink} href={'/sub-only-download-credits'} prefetch={false}
                              onClick={onClickTrack('Navbar Item', {navbar_item: 'Download Subscription-Only VODs'})}
                              aria-label="Download Subscription-Only VODs">
                            Download Subscription-Only VODs
                        </Link>
                    </NavbarItem> : null
                }

                {isRumble ?
                    <NavbarItem className="hidden sm:flex" isActive={pathname === '/rumble-most-followed-channels'}>
                        <Link as={NextLink} href="/rumble-most-followed-channels" prefetch={false}
                              onClick={onClickTrack('Navbar Item', {navbar_item: 'Most Followed Rumble Channels'})}
                              aria-current={pathname === '/rumble-most-followed-channels' ? 'page' : undefined}
                              aria-label="Most Followed Rumble Channels">
                            Most Followed Channels
                        </Link>
                    </NavbarItem> : null
                }

                {isRumble ?
                    <NavbarItem className="hidden lg:flex" isActive={pathname === '/rumble-most-viewed-channels'}>
                        <Link as={NextLink} href="/rumble-most-viewed-channels" prefetch={false}
                              onClick={onClickTrack('Navbar Item', {navbar_item: 'Most Viewed Rumble Channels'})}
                              aria-current={pathname === '/rumble-most-viewed-channels' ? 'page' : undefined}
                              aria-label="Most Viewed Rumble Channels">
                            Most Viewed Channels
                        </Link>
                    </NavbarItem> : null
                }

                {/*{isRumble ?*/}
                {/*    <NavbarItem className="hidden sm:flex">*/}
                {/*        <Link as={NextLink} href={'/rumble-statistics'} prefetch={false}*/}
                {/*              onClick={onClickTrack('Navbar Item', {navbar_item: 'Rumble Statistics'})}*/}
                {/*              aria-label="Rumble Statistics">*/}
                {/*            Rumble Statistics*/}
                {/*        </Link>*/}
                {/*    </NavbarItem> : null*/}
                {/*}*/}

                <NavbarItem>
                    <Dropdown>
                        <DropdownTrigger>
                            <Link as={Button} variant={"light"}
                                  endContent={<ChevronDown fill="currentColor" size={16}/>} href="#"
                                  onClick={onClickTrack('Navbar Item', {navbar_item: 'Onboarding'})}
                                  aria-label="Onboarding">
                                More
                            </Link>
                        </DropdownTrigger>
                        <DropdownMenu
                            onAction={onAction}
                            aria-label="Onboarding hints"
                            className="w-[340px] max-w-[calc(100vw-2rem)]"
                            itemClasses={{
                                base: "gap-4",
                            }}
                        >
                            {menuItems.map((item) => (
                                <DropdownItem
                                    key={item.url}
                                >
                                    {item.title}
                                </DropdownItem>
                            ))}
                        </DropdownMenu>
                    </Dropdown>
                </NavbarItem>
                <NavbarItem className="hidden">
                    {menuItems.map((item) => (
                        <NextLink
                            href={item.url}
                            key={item.url}
                            prefetch={false}
                        >
                            {item.title}
                        </NextLink>
                    ))}
                </NavbarItem>
            </NavbarContent>
        </NextUINavbar>
    );
};


export const ChevronDown = ({fill, size, height, width, ...props}) => {
    return (
        <svg
            fill="none"
            height={size || height || 24}
            viewBox="0 0 24 24"
            width={size || width || 24}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="m19.92 8.95-6.52 6.52c-.77.77-2.03.77-2.8 0L4.08 8.95"
                stroke={fill}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit={10}
                strokeWidth={1.5}
            />
        </svg>
    );
};